import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VSheet,{staticClass:"pa-4",attrs:{"elevation":"1","width":"100%","height":"80"}},[(_vm.loading)?_c(VSkeletonLoader,{staticClass:"ml-n3",attrs:{"type":"list-item-avatar"}}):_c('h1',[_vm._v(" "+_vm._s(_vm.value)+" "),(_vm.label)?_c('small',{staticClass:"pl-2 text-subtitle-1"},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }